import type { FluxErrorCode } from '../errors.codes.js';
import { getFluxErrorCategory } from './get-flux-error-category.util.js';

export function getFluxErrorDocPaths(errorCode: FluxErrorCode): string {
  if (!errorCode.includes('/')) {
    return '/wiki/docs/error-codes/codes/generic/index.html#' + errorCode;
  }

  const category = getFluxErrorCategory(errorCode);
  if (!category) {
    return '/wiki/docs/error-codes/index.html';
  }

  const isPartOfGroup = category.group;

  const highlightHash = `#${errorCode}`;

  if (isPartOfGroup) {
    return `/wiki/docs/error-codes/codes/${isPartOfGroup}/index.html${highlightHash}`;
  }

  return `/wiki/docs/error-codes/codes/${category.key}/index.html${highlightHash}`;
}
